<template>
  <div class="orientation-message">
    <div class="modal-background"></div>
    <div class="orientation-message-container">
      <img src="~@/assets/orientation-icon.svg" />
      <p>Before beginning this experience, please rotate your device to landscape orientation!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orientation-message'
}
</script>

<style lang="scss" scoped>
.modal-background {
  background: rgba(0,0,0,0.5);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
.orientation-message-container {
  background: #fff;
  box-sizing: border-box;
  color: #4A4A4A;
  font-size: 20px;
  left: 50%;
  line-height: 24px;
  padding: 50px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 292px;
}
</style>
